export enum EnumBillingQueryKeys {
  BILLING_OFFERS = 'BILLING_OFFERS',
  CORPORATE_PAYMENT_METHODS = 'CORPORATE_PAYMENT_METHODS',
  USER_SEPA_DETAILS = 'USER_SEPA_DETAILS',
  CORPORATE_BILLING_RECORDS = 'CORPORATE_BILLING_RECORDS',
  CORPORATE_INVOICING_DOCUMENTS = 'CORPORATE_INVOICING_DOCUMENTS',
  INVOICING_DOCUMENT_BLOB = 'INVOICING_DOCUMENT_BLOB',
}
